import moment from "moment";

export const dateFormat = (value: string) => {
    return moment(value).format('MM-DD-YYYY')
};

// Accounting bill and invoice dates are calendar dates, not instants in time.
// Format the date portion supplied by the API without applying the browser's
// timezone, which can otherwise display UTC midnight as the previous day.
export const dateOnlyFormat = (value: string | null | undefined) => {
    if (!value) {
        return '';
    }

    const calendarDate = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (calendarDate) {
        return `${calendarDate[2]}-${calendarDate[3]}-${calendarDate[1]}`;
    }

    return moment.parseZone(value).format('MM-DD-YYYY');
};

export const dateTimeFormat = (value: string) => {
    return moment(value).format('MM-DD-YYYY HH:mm')
};

export const offerPaymentDateFormat = (
    submittedToVendorDate: string | null | undefined,
    paymentPeriodInDays: number | null | undefined,
) => {
    if (!submittedToVendorDate || paymentPeriodInDays == null || !Number.isFinite(paymentPeriodInDays)) {
        return 'Not available';
    }

    // Preserve the offset supplied by the API. Converting the submission
    // timestamp to the browser timezone can move the resulting payment date
    // across a calendar-day boundary.
    const submittedDate = moment.parseZone(submittedToVendorDate, moment.ISO_8601, true);
    if (!submittedDate.isValid() || submittedDate.year() <= 1) {
        return 'Not available';
    }

    return submittedDate.add(paymentPeriodInDays, 'days').format('MM-DD-YYYY');
};

//export const expirationDateStatus = (SubmittedToVendorDate: string, OfferExpirationDays: number) => {
//    const now = new Date();
//    const expiration = new Date(new Date(SubmittedToVendorDate).getTime() + (OfferExpirationDays * 24 * 60 * 60 * 1000));
//    const timediff = expiration.getTime() - now.getTime();
//    return timediff < 0;
//}
export const expirationDateStatus = (SubmittedToVendorDate: string, OfferExpirationDays: number) => {
    const now = moment();
    const expiration = moment(SubmittedToVendorDate).add(OfferExpirationDays, 'days');
    debugger;
    return now.isAfter(expiration);
}
export const expirationDateTimeFormat = (SubmittedToVendorDate: string, OfferExpirationDays: number) => {
    const now = new Date();
    const expiration = new Date(new Date(SubmittedToVendorDate).getTime() + (OfferExpirationDays * 24 * 60 * 60 * 1000));
    const timeDiff = expiration.getTime() - now.getTime();
    const diffDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    return `${diffDays} d ${diffHours} h ${diffMinutes} m`;

}
export const expirationTimeFormat = (SubmittedToVendorDate: string, OfferExpirationDays: number) => {
    const expiration = new Date(new Date(SubmittedToVendorDate).getTime() + (OfferExpirationDays * 24 * 60 * 60 * 1000));
    return ` ${moment(expiration).format('MM-DD-YYYY HH:mm')}`;
}

